import '~/js/modules/stickyNav';
import '~/js/views/resorts/includes/scroll-below';

import PalmSuites from '~/js/views/resorts/components/palm-suites/PalmSuites';

// Variable Declaration
const palmSuites = query('#palm-suites');

// Render react component
ReactDOM.render(<PalmSuites />, palmSuites);
